import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectUser } from "../store/userSlice";
import { useNavUtils } from "../utils/navUtils";
import UserWidgetContainer from "./utils/UserWidgetContainer";
import config from "../utils/config";
import "../styles/components/UserLogoutBar.css";

const UserLogoutBar: React.FC = () => {
  const { t } = useTranslation();
  
  if (!config.showUserLoginStatus) {
    return null;
  }

  const { logoutReset, goNav, getLoginTarget } = useNavUtils();
  const reduxUser = useSelector(selectUser);

  const handleLogout = async () => {
    const loginTarget = getLoginTarget();
    await logoutReset();
    // Because this page is NOT covered by the auth-required
    // context, we have to explicitly navigate to the login page.
    goNav(loginTarget);
  };

  return (
    <div className="user-logout-bar">
      {reduxUser ? (
        <UserWidgetContainer/>
      ) : (
        <button className="user-logout-button" onClick={handleLogout}>
          {t("user.loggedOut")}
        </button>
      )}
    </div>
  );
};

export default UserLogoutBar;
